import {
    DescriptionWindowActionType,
    IDescriptionWindowState,
} from '../../types/descriptionWindow'

const initialState: IDescriptionWindowState = {
    show: false,
    coordinates: {
        x: window.innerWidth / 2 - 300,
        y: window.innerHeight / 2 - 500,
    },
    size: { width: 300, height: 500 },
    data: {
        header: '',
        description: '',
    },
}

export function descriptionWindowReducer(
    state = initialState,
    action: any
): IDescriptionWindowState {
    switch (action.type) {
        case DescriptionWindowActionType.SHOW_DESCRIPTION_WINDOW:
            return {
                ...state,
                show: true,
            }

        case DescriptionWindowActionType.HIDE_DESCRIPTION_WINDOW:
            return {
                ...state,
                show: false,
                data: {
                    header: '',
                    description: '',
                },
            }

        case DescriptionWindowActionType.CHANGE_COORDINATES:
            return {
                ...state,
                coordinates: { x: action.payload.x, y: action.payload.y },
            }

        case DescriptionWindowActionType.CHANGE_SIZE:
            return {
                ...state,
                size: action.payload,
            }

        case DescriptionWindowActionType.SET_DESCRIPTION_DATA:
            return {
                ...state,
                data: action.payload,
            }

        default:
            return state
    }
}
